import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getEternalProfileApi } from 'shared-ui/api'

export const fetchEternalProfile = createAsyncThunk(
  'eternalProfile/fetchEternalProfile',
  async (user_id, thunkAPI) => {
    try {
      const response = await getEternalProfileApi(user_id)
      return response.data
    } catch (error) {
      const message =
        typeof error === 'string'
          ? error
          : error?.detail || error?.message || JSON.stringify(error)
      return thunkAPI.rejectWithValue(message)
    }
  }
)

const eternalProfileSlice = createSlice({
  name: 'eternalProfile',
  initialState: {
    profile: JSON.parse(localStorage.getItem('eternalProfile')) || null,
    status: 'idle',
    error: null,
  },
  reducers: {
    clearEternalProfileError(state) {
      state.error = null
    },
    resetEternalProfile(state) {
      state.profile = null
      state.status = 'idle'
      state.error = null
      localStorage.removeItem('eternalProfile')
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEternalProfile.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(fetchEternalProfile.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.profile = action.payload
        localStorage.setItem('eternalProfile', JSON.stringify(action.payload))
      })
      .addCase(fetchEternalProfile.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.payload
      })
  },
})

export const { clearEternalProfileError, resetEternalProfile } =
  eternalProfileSlice.actions

export default eternalProfileSlice.reducer
